import React, { useState, useEffect } from "react";
import { Card, Row, Col, Container, Button, Image, Spinner } from "react-bootstrap";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import "../components/usuariocoop.css";
import SocialBar from "../components/SocialBar";
import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';

const API_URL ="https://facach.coop.hn/api";

// Fallback estático por si la API falla
const FALLBACK = [
  { id: 1, name: "Usuario Financiero", description: "Encuentre nuestras hojas de Información y obténgala aquí", color: "#F26A63", file_url: "https://facach.coop.hn/_files/ugd/3a8449_cbda850270b04effa336bf63b2fb5ae7.pdf" },
  { id: 2, name: "Tasas activas y pasivas", description: "Encuentre nuestras hojas con más información y obténgala aquí", color: "#F9A94A", file_url: "https://facach.coop.hn/_files/ugd/3a8449_46a15ac14ba84963934114a40f552366.pdf" },
  { id: 3, name: "Educación Financiera", description: "Encuentre nuestras hojas con más información y obténgala aquí", color: "#F2D45C", file_url: "https://facach.coop.hn/_files/ugd/3a8449_de5bc7f53424424e85f6f5c881f515e1.pdf" },
  { id: 4, name: "Derechos y deberes de los Cooperativistas", description: "Encuentre nuestras hojas con más información y obténgala aquí", color: "#6FCF97", file_url: "https://facach.coop.hn/_files/ugd/3a8449_ba1691c21b934dd28ce0b15159381833.pdf" },
  { id: 5, name: "Hojas de Reclamación", description: "Encuentre nuestras hojas de Información y obténgala aquí", color: "#56CCF2", file_url: "https://facach.coop.hn/_files/ugd/3a8449_3b8b0ffdde464a388b41d5cbb6270d29.pdf" },
  { id: 6, name: "Catálogo de Servicios", description: "Encuentre nuestras hojas con más información y obténgala aquí", color: "#2F80ED", file_url: "https://facach.coop.hn/_files/ugd/182ee1_04ecbb014c8e4ff0a8ad989570f7a481.pdf" },
  { id: 7, name: "Cálculo CAT", description: "FACACH le facilita la matriz de cálculo de Costo Anual Total", color: "#9B51E0", file_url: "https://facach.coop.hn/_files/ugd/3a8449_5115561ec226456da40d39f43f29463c.xlsx" },
  { id: 8, name: "Contrato de Adhesión Préstamo Automático", description: "Encuentre nuestras hojas de CONTRATO DE ADHESIÓN PRÉSTAMO AUTOMÁTICO", color: "#2D4C9A", file_url: "https://facach.coop.hn/_files/ugd/3a8449_d0a3d4438fba4aee803ce9c72513a554.pdf" },
  { id: 9, name: "Contrato de Adhesión Préstamo Hipotecario", description: "Encuentre nuestras hojas de CONTRATO DE ADHESIÓN PRÉSTAMO HIPOTECARIO", color: "#F26A63", file_url: "https://facach.coop.hn/_files/ugd/3a8449_8318f2392d2d44c7b7604c2828645dfd.pdf" },
];

function UsuarioCooperativo() {
  const { settings } = useSiteSettings();
  const bannerSrc = settings.banner_image
    ? `https://facach.coop.hn${settings.banner_image}`
    : fallbackBanner;

  const [docs, setDocs] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res = await fetch(`${API_URL}/cooperative-user-docs`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok && json.data?.length > 0) setDocs(json.data);
      } catch (err) {
        console.error("Error cargando documentos usuario cooperativo:", err.message);
      } finally { setLoading(false); }
    };
    fetch_();
  }, []);

  return (
    <>
      <NavbarFacach />

      {/* Banner — solo título */}
      <div className="banner-wrapper">
        <Image src={bannerSrc} alt="Usuario Cooperativo - FACACH" fluid className="banner-image" />
        <div className="banner-overlay">
          <h1 className="banner-title">USUARIO COOPERATIVO</h1>
        </div>
      </div>

      {/* Descripción debajo del banner */}
      <div style={{ background: "#f8f9fa", padding: "0px 24px 0", textAlign: "center" }}>
        <p style={{
          color: "#1a3a6b", maxWidth: 750, margin: "0 auto",
          fontSize: "clamp(0.95rem, 1.5vw, 1.1rem)", lineHeight: 1.7, fontWeight: 500,
        }}>
          FACACH como parte de su compromiso con los usuarios cooperativos le
          brinda toda la información sobre los derechos y deberes que usted
          tiene como usuario cooperativo, construyendo un sector más
          fortalecido y dinámico.
        </p>
      </div>

      <div className="fondo-suave">
        <Container className="py-4">
          {/* tarjetas */}
        </Container>
      </div>
      <div className="fondo-suave">
        <Container className="py-2">
          {/* tarjetas aquí, sin el párrafo de descripción */}
        </Container>
      </div>

      <div className="fondo-suave">
        <Container className="py-5">


          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Row xs={1} md={2} lg={3} className="g-4">
              {docs.map(doc => (
                <Col key={doc.id}>
                  <Card className="card-facach" style={{ backgroundColor: doc.color }}>
                    <Card.Body>
                      <Card.Title style={{ color: "#fff" }}>
                        {doc.name}
                      </Card.Title>
                      <Card.Text style={{ color: "#fff" }}>
                        {doc.description}
                      </Card.Text>
                      {doc.file_url ? (
                        <Button
                          variant="light"
                          size="sm"
                          href={doc.file_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Descargar
                        </Button>
                      ) : (
                        <Button variant="light" size="sm" disabled style={{ opacity: 0.5 }}>
                          Próximamente
                        </Button>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Container>
        <SocialBar position="right" top="35%" size={42} rounded={true} />
      </div>
      <FooterFacach />
    </>
  );
}

export default UsuarioCooperativo;